import { forwardRef } from 'react'

import { Text, theme } from '@hhgtech/hhg-components'
import dayjs from 'dayjs'
import { useIntl } from 'react-intl'

import { useCurrentUrl } from 'hooks/useCurrentUrl'
import { useRouterExtend } from 'hooks/useRouterExtend'
import { DEFAULT_FRUIT_ICON } from 'interfaces/constants'
import { DATE_FORMAT_BY_LOCALE } from 'interfaces/constants/pregenancyCategory'

import { StyledWeekOption } from './index.styled'

export interface ItemProps extends React.ComponentPropsWithoutRef<'div'> {
  value: string
  label: string
  fruitIcon?: string
  firstDay?: Date
  isSelected?: boolean
}

export const WeekOption = forwardRef<HTMLDivElement, ItemProps>(
  function WeekOption(
    {
      value,
      fruitIcon = '',
      firstDay = new Date(),
      isSelected,
      className,
      ...others
    }: ItemProps,
    ref,
  ) {
    const { formatMessage: f } = useIntl()
    const { locale } = useRouterExtend()
    const firstDateOfWeek = dayjs(firstDay).add(Number(value) * 7, 'day')
    const lastDateOfWeek = dayjs(firstDay).add(Number(value) * 7 + 7, 'day')
    const currentUrl = useCurrentUrl()
    return (
      <StyledWeekOption
        ref={ref}
        data-selected={isSelected}
        {...others}
        className={`${className} pointer-event-child-none`}
        data-event-category="Health Tool"
        data-event-action="Due Date Week Click"
        data-event-label={currentUrl}
      >
        <img
          loading="lazy"
          src={fruitIcon || DEFAULT_FRUIT_ICON}
          alt={fruitIcon}
          style={{ width: '32px' }}
        />
        <div>
          <Text size="s3" type="semiBold">
            {f(
              {
                id: 'dueDateTool.weekNumber',
                defaultMessage: 'Week {weekNumber}',
              },
              {
                weekNumber: value,
              },
            )}
          </Text>
          <Text size="p4" color={theme.colors.gray800}>
            {`${firstDateOfWeek.format(
              DATE_FORMAT_BY_LOCALE[locale],
            )} - ${lastDateOfWeek.format(DATE_FORMAT_BY_LOCALE[locale])} `}
          </Text>
        </div>
      </StyledWeekOption>
    )
  },
)
